import React, { useCallback, useEffect } from 'react'
import { Box, Button, IconButton, Typography, MenuItem, Popover, MenuList, Modal, Divider, CircularProgress } from '@mui/material';
import Title from '../Dashboard/Title';
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import InputBase from "@mui/material/InputBase";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Link, useParams } from 'react-router-dom';
import AddQuestion from './Modals/AddQuestion';
import { useSelector } from 'react-redux';
import api from "../../services/CBT";
import EditQuestion from './Modals/EditQuestion';
import { toast } from 'react-toastify';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { lg: 800, xs: 400 },
  height: "600px",
  bgcolor: "background.paper",
  borderRadius: "10px",
  border: "1px solid #671E78",
  boxShadow: 24,
  p: 4,
  overflowY: "scroll",
};

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: "rgba(103, 30, 120, 0.1)",
    fontFamily: "Gilroy-Bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Gilroy-Regular",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: " rgba(103, 30, 120, 0.1)",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export const CBTThird = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [setupData, setSetupData] = React.useState([]);
  const [loading, setLoading] = React.useState([]);
  const [selectedQuestion, setSelectedQuestion] = React.useState(null);
  const { admToken, user } = useSelector((state) => state.auth);
  const { subject: encodedSubject, title: encodedTitle, id, subjectId } = useParams();
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const handleOpenDeleteModal = () => setOpenDeleteModal(true);
  const handleCloseDeleteModal = () => setOpenDeleteModal(false);
  const [selectedQuestionId, setSelectedQuestionId] = React.useState(null);

  const subject = decodeURIComponent(encodedSubject || '');
  const title = decodeURIComponent(encodedTitle || '');

  const handleOpenModal = () => setOpenModal(true);
  const handleOpenEditModal = () => setOpenEditModal(true);

  const handleClick = (event, question) => {
    setAnchorEl(event.currentTarget);
    setSelectedQuestion(question);
    setSelectedQuestionId(question.questionId)
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleClose();
    handleOpenEditModal();
  };

  const getCTBQuestion = useCallback(async () => {
    try {
      setLoading(true)
      const res = await api.getCBTQuestionsList(admToken, user.schoolId, subjectId, id);
      if (res.status && res.statusCode === 2) {
        setSetupData(res.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error.response);
      setLoading(false);
      console.log("error");
    }
  }, [admToken]);

  const handleDelete = useCallback(async () => {
    try {
      if (!selectedQuestionId) return;

      const res = await api.deleteCBTQuestion(admToken, selectedQuestionId);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message, {
          autoClose: 4000,
          position: toast.POSITION.BOTTOM_LEFT,
        });
        getCTBQuestion();
        handleCloseDeleteModal();
        handleClose();
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed to delete question");
    }
  }, [admToken, selectedQuestionId, getCTBQuestion]);

  useEffect(() => {
    getCTBQuestion();
  }, [admToken]);

  const handleCloseModal = () => {
    setOpenModal(false)
    getCTBQuestion();
  };

  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    getCTBQuestion();
  };


  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress size={60} sx={{ color: "#671E78" }} />
      </Box>
    );
  }

  const open = Boolean(anchorEl);
  const SeletcetdItemId = open ? "simple-popover" : undefined;

  return (
    <>
      <Box>
        <Box>
          <Title title="CBT - Add Question" />
        </Box>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography variant='h6' sx={{ fontFamily: 'Gilroy-Medium' }}>{subject || ''}</Typography>
          <Button
            variant='contained'
            sx={{ textTransform: 'initial', fontFamily: 'Gilroy-Regular', marginTop: "5px" }}
            onClick={handleOpenModal}
          >
            Add Question
          </Button>
        </Box>
        <Box mt={3}>
          <Link to="/cbt">
            <IconButton sx={{ bgcolor: '#671e781a' }}>
              <KeyboardBackspaceIcon sx={{ color: '#671E78' }} />
            </IconButton>
          </Link>
          <Typography variant='caption' sx={{ fontFamily: 'Gilroy-Medium', ml: 2 }}>Back to Quiz</Typography>
        </Box>
        <Box mt={5} sx={{ border: "1px solid #671E78", borderRadius: "20px" }}>
          <TableContainer>
            <Table sx={{ minWidth: 700, fontFamily: "Gilroy-Regular" }} aria-label="customized table">
              <TableHead sx={{ backgroundColor: "rgba(103, 30, 120, 0.1)", width: "100%" }}>
                <TableRow>
                  <StyledTableCell>Question</StyledTableCell>
                  <StyledTableCell align='right'></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody sx={{ fontFamily: "Gilroy-Regular" }}>
                {setupData.map((data, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell component="th" scope="row">
                      {data.question}
                    </StyledTableCell>
                    <StyledTableCell align='right'>
                      <IconButton onClick={(e) => handleClick(e, data)}>
                        <MoreVertIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      <Popover
        id={SeletcetdItemId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ bgcolor: "#671E78", color: "#fff", fontFamily: "Gilroy-Regular", px: 3 }}>
          <MenuList>
            <MenuItem
              sx={{ fontFamily: "Gilroy-Regular" }}
              onClick={handleEdit}
            >
              Edit
            </MenuItem>
            <MenuItem
              sx={{ fontFamily: "Gilroy-Regular" }}
              onClick={() => {
                if (selectedQuestion) {
                  handleClose();
                  handleOpenDeleteModal();
                }
              }}
            >
              Delete
            </MenuItem>
          </MenuList>
        </Box>
      </Popover>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box align="right">
            <IconButton onClick={handleCloseModal}>
              <HighlightOffIcon />
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h4" sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}>
              Add Question
            </Typography>
            <Divider />
          </Box>
          <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
            <AddQuestion
              id={id}
              subjectId={subjectId}
              subject={subject}
              title={title}
              onSuccess={() => {
                handleCloseModal();
                getCTBQuestion();
              }}
            />
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openEditModal}
        onClose={handleCloseEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box align="right">
            <IconButton onClick={handleCloseEditModal}>
              <HighlightOffIcon />
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h4" sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}>
              Edit Question
            </Typography>
            <Divider />
          </Box>
          <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
            {selectedQuestion && (
              <EditQuestion
                id={selectedQuestion?.questionRef}
                subjectId={subjectId}
                subject={subject}
                title={title}
                questionData={selectedQuestion}
                onSuccess={() => {
                  handleCloseEditModal();
                  getCTBQuestion();
                }}
              />
            )}
          </Box>
        </Box>
      </Modal>
      <Modal
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        aria-labelledby="delete-confirmation-modal"
      >
        <Box sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 4,
        }}>
          <Typography variant="h6" sx={{ fontFamily: "Gilroy-Medium", mb: 2 }}>
            Confirm Delete
          </Typography>
          <Typography variant="body1" sx={{ fontFamily: "Gilroy-Regular", mb: 3 }}>
            Are you sure you want to delete this question?
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button
              variant="outlined"
              onClick={handleCloseDeleteModal}
              sx={{ textTransform: 'initial', fontFamily: "Gilroy-Regular" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleDelete}
              sx={{
                textTransform: 'initial',
                fontFamily: "Gilroy-Regular",
                bgcolor: '#671E78',
                '&:hover': { bgcolor: '#4e165a' }
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  )
}
